import React, { Component } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';

// backgroundImage for Sidebar
import image from "../../assets/img/full-screen-image-3.jpg";
// image for avatar in Sidebar
import avatar from "../../assets/img/grass-1.jpg";
import admin from "../../assets/img/anonymous-512.png";
import health from "../../assets/img/health-1.jpg";
import leisure from "../../assets/img/leisure-1.jpg";
// logo for sidebar
import logo from "../../assets/img/logo_white_transparent.png";

import dashboardRoutes from "../../routes/dashboard.jsx";

const bgImage = { backgroundImage: "url(" + image + ")" };

var ps;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openProfile: false,
      openTenants: false,
      openArtists: false,
      openClauses: false,
      openManageConsent: false,
      isWindows: navigator.platform.indexOf("Win") > -1 ? true : false,
      width: window.innerWidth,
    };
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    // add event listener for windows resize
    window.addEventListener("resize", this.updateDimensions.bind(this));
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }

  componentDidUpdate() {
    if (navigator.platform.indexOf("Win") > -1) {
      setTimeout(() => {
        ps.update();
      }, 350);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
      //let test = this.props.userLoggedIn[0].Userid;
      //debugger;
    return (
      <div className="sidebar" data-color="grey" data-image={image}>
        <div className="sidebar-background" style={bgImage} />
        <div className="logo">
          <a
            href="https://consent.tattooreleaseonline.com"
            className="simple-text logo-mini"
          >
              <div className="logo-img">
                  <img src={logo} alt="tro-logo"/>
              </div>
          </a>
          <a
            href="https://consent.tattooreleaseonline.com"
            className="simple-text logo-text"
          >
            <p> </p>
          </a>
        </div>
        <div className="sidebar-wrapper" ref="sidebarWrapper">
            <div>
                {(this.props.userLoggedIn[0].status) || (this.props.userLoggedIn[0].role === "Kiosk") ?
                    <div className="user">
                        <div className="photo">
                            <img src={admin} alt="Avatar"/>
                        </div>
                        <div className="info">
                            <a
                                onClick={() =>
                                    this.setState({openAvatar: !this.state.openAvatar})
                                }
                            >
                    <span>
                        {this.props.userLoggedIn[0].Fname + " " + this.props.userLoggedIn[0].Lname }
                      <b
                          className={
                              this.state.openAvatar ? "caret rotate-180" : "caret"
                          }
                      />
                    </span>
                            </a>
                            <Collapse in={this.state.openAvatar}>
                                <ul className="nav">
                                    {(this.props.userLoggedIn[0].status) ?
                                        <li
                                            className={this.activeRoute("/Profile")}
                                        >
                                            <NavLink
                                                to={"/profile"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <a
                                                    onClick={() =>
                                                        this.setState({openProfile: !this.state.openProfile})
                                                    }
                                                >
                                                    <b
                                                        className={
                                                            this.state.openProfile ? "caret rotate-180" : "caret"
                                                        }
                                                    />
                                                </a>

                                                <span className="sidebar-mini">
                                                  {"MP"}

                                                </span>
                                                    <span className="sidebar-normal">
                                              {"My Profile"}
                                            </span>
                                                </NavLink>
                                                <Collapse in={this.state.openProfile}>
                                                    <ul style={{listStyle: "none"}}>
                                                        <li
                                                            className={this.activeRoute("/mysubscription")}
                                                        >
                                                            <NavLink
                                                                to={"/mysubscription"}
                                                                className="nav-link"
                                                                activeClassName="active"
                                                            >
                                              <span className="sidebar-mini">
                                                {"MS"}
                                              </span>
                                                                <span className="sidebar-normal">
                                                {"Manage Subscription"}
                                              </span>
                                                            </NavLink>
                                                        </li>
                                                    </ul>
                                                </Collapse>
                                        </li>
                                        :
                                        <div></div>
                                    }
                                  {(this.props.userLoggedIn[0].role === "Admin") ?
                                    <li
                                        className={this.activeRoute("/tenants")}
                                    >

                                        <NavLink
                                            to={"/tenants"}
                                            className="nav-link"
                                            activeClassName="active"
                                        >

                                            <a
                                                onClick={() =>
                                                    this.setState({openTenants: !this.state.openTenants})
                                                }
                                            >
                                                <b
                                                    className={
                                                        this.state.openTenants ? "caret rotate-180" : "caret"
                                                    }
                                                />
                                            </a>

                                            <span className="sidebar-mini">
                                          {"MT"}

                                        </span>

                                            <span className="sidebar-normal">

                                          {"Manage Tenants"}

                                        </span>

                                        </NavLink>
                                        <Collapse in={this.state.openTenants}>
                                            <ul style={{listStyle: "none"}}>
                                                <li
                                                    className={this.activeRoute("/addtenant")}
                                                >
                                                    <NavLink
                                                        to={"/addtenant"}
                                                        className="nav-link"
                                                        activeClassName="active"
                                                    >
                                          <span className="sidebar-mini">
                                            {"AT"}
                                          </span>
                                                        <span className="sidebar-normal">
                                            {"Add Tenant"}
                                          </span>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </Collapse>
                                    </li>
                                    :
                                    <div></div>
                                }
                                    {((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) ?
                                        <li
                                            className={this.activeRoute("/kioskusers")}
                                        >
                                            <NavLink
                                                to={"/kioskusers"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <a
                                                    onClick={() =>
                                                        this.setState({openKioskusers: !this.state.openKioskusers})
                                                    }
                                                >
                                                    <b
                                                        className={
                                                            this.state.openKioskusers ? "caret rotate-180" : "caret"
                                                        }
                                                    />
                                                </a>
                                                <span className="sidebar-mini">
                                          {"KU"}

                                        </span>
                                                <span className="sidebar-normal">
                                          {"Manage Kiosk Users"}
                                        </span>
                                            </NavLink>
                                            <Collapse in={this.state.openKioskusers}>
                                                <ul style={{listStyle: "none"}}>
                                                    <li
                                                        className={this.activeRoute("/addkioskuser")}
                                                    >
                                                        <NavLink
                                                            to={"/addkioskuser"}
                                                            className="nav-link"
                                                            activeClassName="active"
                                                        >
                                          <span className="sidebar-mini">
                                            {"AK"}
                                          </span>
                                                            <span className="sidebar-normal">
                                            {"Add Kiosk User"}
                                          </span>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </Collapse>
                                        </li>
                                        :
                                        <div></div>
                                    }
                                    {((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) ?
                                        <li
                                            className={this.activeRoute("/artists")}
                                        >
                                            <NavLink
                                                to={"/artists"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <a
                                                    onClick={() =>
                                                        this.setState({openArtists: !this.state.openArtists})
                                                    }
                                                >
                                                    <b
                                                        className={
                                                            this.state.openArtists ? "caret rotate-180" : "caret"
                                                        }
                                                    />
                                                </a>
                                                <span className="sidebar-mini">
                                          {"MA"}

                                        </span>
                                                <span className="sidebar-normal">
                                          {"Manage Artists"}
                                        </span>
                                            </NavLink>
                                            <Collapse in={this.state.openArtists}>
                                                <ul style={{listStyle: "none"}}>
                                                    <li
                                                        className={this.activeRoute("/addclause")}
                                                    >
                                                        <NavLink
                                                            to={"/addartist"}
                                                            className="nav-link"
                                                            activeClassName="active"
                                                        >
                                          <span className="sidebar-mini">
                                            {"AR"}
                                          </span>
                                                            <span className="sidebar-normal">
                                            {"Add Artist"}
                                          </span>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </Collapse>
                                        </li>
                                        :
                                        <div></div>
                                    }
                                  {((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) ?
                                      <li
                                          className={this.activeRoute("/clauses")}
                                      >
                                        <NavLink
                                            to={"/clauses"}
                                            className="nav-link"
                                            activeClassName="active"
                                        >
                                          <a
                                              onClick={() =>
                                                  this.setState({openClauses: !this.state.openClauses})
                                              }
                                          >
                                            <b
                                                className={
                                                  this.state.openClauses ? "caret rotate-180" : "caret"
                                                }
                                            />
                                          </a>
                                          <span className="sidebar-mini">
                                          {"MC"}

                                        </span>
                                          <span className="sidebar-normal">
                                          {"Manage Clauses"}
                                        </span>
                                        </NavLink>
                                        <Collapse in={this.state.openClauses}>
                                          <ul style={{listStyle: "none"}}>
                                            <li
                                                className={this.activeRoute("/addclause")}
                                            >
                                              <NavLink
                                                  to={"/addclause"}
                                                  className="nav-link"
                                                  activeClassName="active"
                                              >
                                          <span className="sidebar-mini">
                                            {"AC"}
                                          </span>
                                                <span className="sidebar-normal">
                                            {"Add Clause"}
                                          </span>
                                              </NavLink>
                                            </li>
                                          </ul>
                                        </Collapse>
                                      </li>
                                      :
                                      <div></div>
                                  }
                                  {((this.props.userLoggedIn[0].status)  && (this.props.userLoggedIn[0].subscription)) ?
                                      <li
                                          className={this.activeRoute("/consents")}
                                      >
                                        <NavLink
                                            to={"/consents"}
                                            className="nav-link"
                                            activeClassName="active"
                                        >
                                          <a
                                              onClick={() =>
                                                  this.setState({openManageConsent: !this.state.openManageConsent})
                                              }
                                          >
                                            <b
                                                className={
                                                  this.state.openManageConsent ? "caret rotate-180" : "caret"
                                                }
                                            />
                                          </a>
                                          <span className="sidebar-mini">
                                    {"MF"}

                                    </span>
                                          <span className="sidebar-normal">
                                    {"Manage Consent Forms"}
                                    </span>
                                        </NavLink>
                                        <Collapse in={this.state.openManageConsent}>
                                          <ul style={{listStyle: "none"}}>
                                              <li
                                                  className={this.activeRoute("/addconsent")}
                                              >
                                                  <NavLink
                                                      to={"/addconsent"}
                                                      className="nav-link"
                                                      activeClassName="active"
                                                  >
                                                  <span className="sidebar-mini">
                                                    {"AC"}
                                                  </span>
                                                              <span className="sidebar-normal">
                                                    {"Add Consent Form"}
                                                  </span>
                                                  </NavLink>
                                              </li>
                                          </ul>
                                        </Collapse>
                                      </li>
                                      :
                                      <div></div>
                                  }
                                    {(this.props.userLoggedIn[0].role === "Admin") ?
                                        <li
                                            className={this.activeRoute("/managesubscriptions")}
                                        >

                                            <NavLink
                                                to={"/managesubscriptions"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <span className="sidebar-mini">
                                          {"SR"}

                                        </span>

                                                <span className="sidebar-normal">

                                          {"Subscription Requests"}
                                        </span>

                                            </NavLink>
                                        </li>
                                        :
                                        <div></div>
                                    }
                                  {(this.props.userLoggedIn[0].status) ?
                                    <li
                                        className={this.activeRoute("/submissions")}
                                    >
                                        <NavLink
                                        to={"/submissions"}
                                        className="nav-link"
                                        activeClassName="active"
                                    >
                                    <a
                                    onClick={() =>
                                      this.setState({openReports: !this.state.openReports})
                                  }
                                    >
                                    <b
                                    className={
                                    this.state.openReports ? "caret rotate-180" : "caret"
                                  }
                                    />
                                    </a>
                                    <span className="sidebar-mini">
                                    {"SU"}

                                    </span>
                                    <span className="sidebar-normal">
                                    {"Submissions"}
                                    </span>
                                    </NavLink>
                                        <Collapse in={this.state.openReports}>
                                            <ul style={{listStyle: "none"}}>
                                                <li
                                                    className={this.activeRoute("/submissions")}
                                                >
                                                    <NavLink
                                                        to={"/submissions"}
                                                        className="nav-link"
                                                        activeClassName="active"
                                                    >
                                                  <span className="sidebar-mini">
                                                    {"SB"}
                                                  </span>
                                                        <span className="sidebar-normal">
                                                    {"My Submissions"}
                                                  </span>
                                                    </NavLink>
                                                </li>
                                                {(this.props.userLoggedIn[0].role === "Admin") ?
                                                <li
                                                    className={this.activeRoute("/allsubmissions")}
                                                >
                                                    <NavLink
                                                        to={"/allsubmissions"}
                                                        className="nav-link"
                                                        activeClassName="active"
                                                    >
                                                  <span className="sidebar-mini">
                                                    {"SB"}
                                                  </span>
                                                        <span className="sidebar-normal">
                                                    {"All Submissions"}
                                                  </span>
                                                    </NavLink>
                                                </li>
                                                    :
                                                    <div></div> }
                                            </ul>
                                        </Collapse>
                                    </li>
                                    :
                                    <div></div>
                                  }
                                    {(this.props.userLoggedIn[0].status) ?
                                        <li
                                            className={this.activeRoute("/help")}
                                        >
                                            <NavLink
                                                to={"/help"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <span className="sidebar-mini">
                                                {"OH"}

                                                </span>
                                                            <span className="sidebar-normal">
                                                {"Online Help"}
                                                </span>
                                            </NavLink>

                                        </li>
                                        :
                                        <div></div>
                                    }
                                    {((this.props.userLoggedIn[0].role === "Kiosk") && (this.props.userLoggedIn[0].subscription)) ?
                                        <li
                                            className={this.activeRoute("/kioskmode")}
                                        >
                                            <NavLink
                                                to={"/kioskmode"}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <span className="sidebar-mini">
                                    {"KM"}

                                    </span>
                                                <span className="sidebar-normal">
                                    {"Kiosk Mode"}
                                    </span>
                                            </NavLink>
                                        </li>
                                        :
                                        <div></div>
                                    }
                                </ul>
                            </Collapse>
                        </div>
                    </div>
                    :
                    <div></div>
                }

            </div>
          <ul className="nav">
            {/* If we are on responsive, we want both links from navbar and sidebar
                            to appear in sidebar, so we render here HeaderLinks */}
            {this.state.width <= 992 ? <HeaderLinks /> : null}
            {/*
                            here we render the links in the sidebar
                            if the link is simple, we make a simple link, if not,
                            we have to create a collapsible group,
                            with the specific parent button and with it's children which are the links
                        */}
            {dashboardRoutes.map((prop, key) => {
              var st = {};
              if(prop.invisible) return null;
              st[prop["state"]] = !this.state[prop.state];
              if (prop.collapse) {
                return (
                    <li className={this.activeRoute(prop.path)} key={key}>
                      <a onClick={() => this.setState(st)}>
                        <i className={prop.icon} />
                        <p>
                          {prop.name}
                          <b
                              className={
                                this.state[prop.state]
                                    ? "caret rotate-180"
                                    : "caret"
                              }
                          />
                        </p>
                      </a>
                      <Collapse in={this.state[prop.state]}>
                        <ul className="nav">
                          {prop.views.map((prop, key) => {
                            return (
                                <li
                                    className={this.activeRoute(prop.path)}
                                    key={key}
                                >
                                  <NavLink
                                      to={prop.path}
                                      className="nav-link"
                                      activeClassName="active"
                                  >
                                <span className="sidebar-mini">
                                  {prop.mini}
                                </span>
                                    <span className="sidebar-normal">
                                  {prop.name}
                                </span>
                                  </NavLink>
                                </li>
                            );
                          })}
                        </ul>
                      </Collapse>
                    </li>
                );
              } else {
                if (prop.redirect) {
                  return null;
                } else {
                  return (
                      <li className={this.activeRoute(prop.path)} key={key}>
                        <NavLink
                            to={prop.path}
                            className="nav-link"
                            activeClassName="active"
                        >
                          <i className={prop.icon} />
                          <p>{prop.name}</p>
                        </NavLink>
                      </li>
                  );
                }
              }
            })}
          </ul>
        </div>

      </div>
    );
  }
}

Sidebar.propTypes = {
    actions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    //debugger;
    return {
        userLoggedIn: state.userLoggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(loginActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);

//export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx